import { Injectable } from '@angular/core';

import { BrandsEnum, BrandThemesEnum, PositionEnum, ThemesEnum } from '@seb/web-design-system/core';
import { ITeaser } from '@seb/web-design-system/teaser';

import { AdditionalMarketingLinks, CategoryAdditionalMarketingPush, CustomMedia } from '../models';
import { BaseStoreService } from '../services/base-store.service';
import { ImageService } from '../services/image.service';
import { LinkMapper } from './link.mapper';

@Injectable({
  providedIn: 'root'
})
export class TeaserMapper {
  constructor(
    private readonly imageService: ImageService,
    private readonly baseStoreService: BaseStoreService
  ) {}

  toITeaser(
    component: CategoryAdditionalMarketingPush,
    themesConfig: string,
    teaserConfig: boolean,
    media?: CustomMedia,
    textConfig?: PositionEnum
  ): ITeaser {
    const brandFound = this.baseStoreService.getBrand(component['brandCorner']);
    const brand = brandFound ? brandFound.id : BrandsEnum.default;
    const links: AdditionalMarketingLinks[] = component.additionalMarketingLinks
      ? component.additionalMarketingLinks.map((link) =>
        LinkMapper.toLink(link['urlLocalized'], link.linkName, link['target'] !== 'sameWindow')
      )
      : [];
    if (!media) {
      media = component.media;
    }
    return {
      content: {
        heading: {
          data: {
            title: component.headline ? component.headline : '',
            description: component.subline ? component.subline : '',
            brandLogo: {
              media: component?.brandLogo?.media ? component?.brandLogo?.media : null,
              position: PositionEnum.top
            }
          },
          textConfig: textConfig
        },
        links
      },
      brand,
      media: this.imageService.normalizeMedia(media),
      themesConfig: themesConfig ? (themesConfig as ThemesEnum.dark | ThemesEnum.light | BrandThemesEnum) : null,
      isEmbedded: teaserConfig
    } as ITeaser;
  }
}
